import React, { useState, useEffect } from "react";
import axios from "axios";
import { 
  Box, Flex, Text, Badge, Grid, Button, Skeleton, useColorMode, 
  Alert, AlertIcon, Input 
} from "@chakra-ui/react";
import { FaArrowLeft } from 'react-icons/fa';
import Logo from "../fitness.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import id from 'date-fns/locale/id';
import { useNavigate } from "react-router-dom";
registerLocale('id', id);

const formatDateToMySQL = (date) => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export default function MealVsReal({ onBack }) {
   const navigate = useNavigate();
  const { colorMode } = useColorMode();
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [range, setRange] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());

  const email = localStorage.getItem('userEmail');
  const selectedDateMYSQL = formatDateToMySQL(selectedDate);

  useEffect(() => {
    if (email) loadData();
  }, [selectedDate, email]);

  const loadData = async () => {
  try {
    setLoading(true);
    setErrorMsg('');
    const res = await axios.get(`${process.env.REACT_APP_API_BASE}/meal-vs-real`, {
      params: { email, date: selectedDateMYSQL }
    });

    console.log('Response API:', res.data); // <- tambah ini

    if (res.data.success) {
      setDays(res.data.days || []);
      setRange(res.data.range || '');
    } else {
      setErrorMsg(res.data.message || 'Meal plan tidak ditemukan');
      setDays([]);
    }
  } catch (err) {
    console.error('Error load meal vs real:', err.response?.data || err.message);
    setErrorMsg('Gagal load data: ' + (err.response?.data?.error || err.message));
    setDays([]);
  } finally {
    setLoading(false);
  }
};

  const formatTanggal = (tgl) => {
    return new Date(tgl).toLocaleDateString('id-ID', {
      weekday: 'short', day: 'numeric', month: 'short'
    });
  };

  return (
    <Box p={4}>
      <Box bg={colorMode === "light"? "black" : "pink.800"} px={4} py={2} color="white" rounded="xl" mb={4}>
        <Flex justify="space-between" align="center">
          <Flex align="center">
            <img src={Logo} style={{ width: '40px', marginRight: '8px' }} alt="logo" />
            <Text fontSize="lg" fontWeight="bold">Meal Vs Real</Text>
          </Flex>
           <Button size="xs" leftIcon={<FaArrowLeft />} variant="outline" colorScheme="whiteAlpha" onClick={() => navigate("/dashboard")}>
            Kembali
          </Button>
        </Flex>
      </Box>

      <Text fontSize="xl" fontWeight="bold" mb={2}>Meal Plan Vs Real 8 Hari</Text>

      <Flex align="center" mb={4} gap={3}>
        <Text fontWeight="semibold">Pilih Tanggal:</Text>
        <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          dateFormat="dd MMM yyyy"
          locale="id"
          customInput={<Input w="180px" />}
        />
        {range && <Badge colorScheme="green">RANGE: {range}</Badge>}
      </Flex>

      {loading? <Skeleton h="400px" rounded="xl" /> :
       errorMsg || days.length === 0? (
        <Alert status="warning" rounded="lg">
          <AlertIcon />
          {errorMsg || `Meal plan tidak ditemukan untuk tanggal ${selectedDateMYSQL}`}
        </Alert>
      ) : (
        days.map(day => (
          <Box key={day.day_number} bg="white" shadow="md" rounded="xl" p={4} mb={4}>
            <Text fontWeight="bold" mb={3}>
              Hari {day.day_number} - {formatTanggal(day.tanggal)} | Target: {(day.target_kkal || 0)} kkal
            </Text>

            <Grid templateColumns={{ base: "1fr", md: "1fr 1fr 1fr" }} gap={4}>
              <Box>
                <Flex justify="space-between" mb={2}>
                  <Text fontWeight="bold">PLAN</Text>
                  <Text fontWeight="bold">{(day.total_plan_kkal || 0).toFixed(0)} kkal</Text>
                </Flex>
                {day.meals.map(m => (
                  <Box key={m.waktu_makan} mb={2}>
                    <Flex justify="space-between">
                      <Text fontSize="sm" fontWeight="semibold">{m.waktu_makan}</Text>
                      <Text fontSize="sm" color="orange.500">{(m.plan_kkal || 0).toFixed(0)} kkal</Text>
                    </Flex>
                    <Text fontSize="xs" color="gray.600">{m.plan_menu || '-'}</Text>
                  </Box>
                ))}
              </Box>

              <Box>
                <Flex justify="space-between" mb={2}>
                  <Text fontWeight="bold">REAL</Text>
                  <Text fontWeight="bold">{(day.total_real_kkal || 0).toFixed(0)} kkal</Text>
                </Flex>
                {day.meals.map(m => (
                  <Box key={m.waktu_makan} mb={2}>
                    <Flex justify="space-between">
                      <Text fontSize="sm" fontWeight="semibold">{m.waktu_makan}</Text>
                      <Text fontSize="sm" color="orange.500">{(m.real_kkal || 0).toFixed(0)} kkal</Text>
                    </Flex>
                    <Text fontSize="xs" color="gray.600">
                      {m.real_menu || <Badge size="sm" colorScheme="gray">Belum diisi</Badge>}
                    </Text>
                  </Box>
                ))}
              </Box>

              <Box bg="orange.50" p={3} rounded="lg" border="2px solid" borderColor="orange.200">
                <Flex justify="space-between" mb={2}>
                  <Text fontWeight="bold">COMPARE</Text>
                  <Text fontWeight="bold" color={(day.selisih_total || 0) > 0? 'red.500' : 'green.500'}>
                    {(day.selisih_total || 0) > 0? '+' : ''}{(day.selisih_total || 0).toFixed(0)} kkal
                  </Text>
                </Flex>
                {day.meals.map(m => (
                  <Flex key={m.waktu_makan} justify="space-between" mb={2}>
                    <Text fontSize="sm" fontWeight="semibold">{m.waktu_makan}</Text>
                    <Text fontSize="sm" color={(m.selisih_kkal || 0) > 0? 'red.500' : 'green.500'}>
                      {(m.selisih_kkal || 0) > 0? '+' : ''}{(m.selisih_kkal || 0).toFixed(0)} kkal
                    </Text>
                  </Flex>
                ))}
              </Box>
            </Grid>
          </Box>
        ))
      )}
    </Box>
  );
}